import { render, staticRenderFns } from "./WalletUnstakeModal.vue?vue&type=template&id=4bca1d00&"
import script from "./WalletUnstakeModal.vue?vue&type=script&lang=js&"
export * from "./WalletUnstakeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports